import React, { useEffect, useState, useContext } from 'react';

import {
  useField,
  useFormService,
  ComparatorContext,
} from '@kizi/comparator-core';
import { FormInput } from '../Form';
import { BasicInput } from './inputs/withFormField';

export const PostcodeFieldWrapper = ({ isStartWidget, ...rest }) => {
  const form = useFormService();
  const { api } = useContext(ComparatorContext);
  const field = useField('getUserInput.postcode', form);

  const [postalCodeInput, setPostalCodeInput] = useState(field?.value);

  const validatePostcode = (callback) => {
    const fetchData = async () => {
      await (api as any)
        .validatePostcode(postalCodeInput)
        .then((isPostcode) => {
          if (!isPostcode) {
            callback();
          }
        });
    };

    if (field?.errors === undefined && field?.value) {
      fetchData();
    }
  };

  useEffect(() => {
    validatePostcode(() =>
      field?.set({
        errors: ['Postcode is onjuist, voer een geldige postcode in'],
      })
    );
  }, [postalCodeInput]);

  if (!field) {
    return null;
  }

  return (
    <>
      {isStartWidget ? (
        <FormInput
          name="postcode"
          component={{
            type: 'Inputs.BasicInput',
            key: 'postcode',
            props: {
              fieldName: 'getUserInput.postcode',
              ...rest,
              customBlur: () => setPostalCodeInput(field?.value),
              type: (field?.value as string)?.length >= 4 ? 'text' : 'tel',
              inputMode:
                (field?.value as string)?.length >= 4 ? 'text' : 'numeric',
              pattern:
                (field?.value as string)?.length >= 4 ? undefined : '[0-9]*',
            },
          }}
        />
      ) : (
        <BasicInput
          _fieldName={field.name}
          {...rest}
          {...field}
          {...{ type: (field?.value as string)?.length >= 4 ? 'text' : 'tel' }}
          {...{
            inputMode:
              (field?.value as string)?.length >= 4 ? 'text' : 'numeric',
          }}
          {...{
            pattern:
              (field?.value as string)?.length >= 4 ? undefined : '[0-9]*',
          }}
          onBlur={(e) => {
            if (typeof field.onBlur === 'function') {
              field.onBlur(e);
              setPostalCodeInput(field.value);
            }
          }}
        />
      )}
    </>
  );
};
